module.exports = __webpack_public_path__ + "img/hosheh_no.e1d03e9e.png";